import { render, staticRenderFns } from "./RrcvPD_Total.vue?vue&type=template&id=124c0e47"
import script from "./RrcvPD_Total.vue?vue&type=script&lang=js"
export * from "./RrcvPD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports